export default import.meta.ROLLDOWN_FILE_URL_G67qYc9IpZda8Klm2euzdA